import { createContext, useContext } from 'react';

const defaultContext = {
  queue: [],
  pendingCount: 0,
  hasFailedPunch: false,
  isOffline: false,
  isStatusUiEnabled: false,
  offlineSnackbarRequested: false,
  onlineSnackbarRequested: false,
  enqueuePunch: async () => {},
  deletePunch: () => {},
  openDrawer: () => {},
  reportApiUnreachable: () => {},
  registerClosePersistentOfflineSnackbar: () => {},
  acknowledgeOfflineSnackbar: () => {},
  acknowledgeOnlineSnackbar: () => {},
};

export const OfflinePunchContext = createContext(defaultContext);

export function useOfflinePunchQueue() {
  return useContext(OfflinePunchContext);
}
